// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__7Z-sJ","box":"WorkspacesBox_box__20BgU","node":"WorkspacesBox_node__1BW7_"};